import { ModuleWithProviders, NgModule } from "@angular/core";
import { TestComponent } from "./components/test/test.component";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgxImageZoomModule } from "ngx-image-zoom";
import { GoogleMapsModule } from "@angular/google-maps";
import { AssetListPaginationComponent } from "./components/asset-list-pagination/asset-list-pagination.component";
import { TranslateModule } from "@ngx-translate/core";
import { ColorSketchModule } from "ngx-color/sketch";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { HasValuePipe } from "./pipes/has-value.pipe";
import { CrudTsComponent } from "./components/crud-ts/crud-ts.component";
import { AiOverviewComponent } from "./components/ai/ai-overview/ai-overview.component";
import { OverviewCardComponent } from "./components/overview-card/overview-card.component";
import { OverviewDetailCardComponent } from "./components/overview-detail-card/overview-detail-card.component";
import { AiSegmentationListComponent } from "./components/ai/ai-segmentation-list/ai-segmentation-list.component";
import { CardComponent } from "./components/card/card.component";
import { GeneratedObjectRepresentationComponent } from "./components/common/generated-object-representation/generated-object-representation.component";
import { BatchImageImportComponent } from "./components/batch-image-import/batch-image-import.component";
import { AiJobMonitoringComponent } from "./components/ai/ai-job-monitoring/ai-job-monitoring.component";
import { DynamicSubstationListComponent } from "./components/dynamic-asset-list/dynamic-substation-list/dynamic-substation-list.component";
import { DynamicCardsComponent } from "./components/entity-model-customization/dynamic-cards/dynamic-cards.component";
import { AssetListHeaderComponent } from "./components/asset-list-header/asset-list-header.component";
import { EmcSearchComponentComponent } from "./components/emc-search-component/emc-search-component.component";
import { FilterChecklistComponent } from "./components/common/filter-checklist/filter-checklist.component";
import { DynamicFilterWindowComponent } from "./components/dynamic-filter-window/dynamic-filter-window.component";
import { FilterDynamicComponent } from "./components/filter-dynamic/filter-dynamic.component";
import { EditInjectionSubstationComponent } from "./components/asset-list/substations/edit-injection-substation/edit-injection-substation.component";
import { AssignTaskModalComponent } from "./components/common/assign-task-modal/assign-task-modal.component";
import { AuditReviewComponent } from "./components/common/audit-review/audit-review.component";
import { SectionInstanceColumnComponent } from "./components/common/section-instance-column/section-instance-column.component";
import { SectionInstanceCardComponent } from "./components/common/section-instance/section-instance-card/section-instance-card.component";
import { AttributeSelectedOptionsRowComponent } from "./components/common/section-instance/attribute-selected-options-row/attribute-selected-options-row.component";
import { AttributeFileRowComponent } from "./components/common/section-instance/attribute-rows/attribute-file-row/attribute-file-row.component";
import { AttributeLocationRowComponent } from "./components/common/section-instance/attribute-rows/attribute-location-row/attribute-location-row.component";
import { AttributeValueRowComponent } from "./components/common/section-instance/attribute-rows/attribute-value-row/attribute-value-row.component";
import { AttributeImageRowComponent } from "./components/common/section-instance/attribute-rows/attribute-image-row/attribute-image-row.component";
import { AttributeNumberEditRowComponent } from "./components/common/section-instance/attribute-rows/attribute-number-edit-row/attribute-number-edit-row.component";
import { AttributeTextEditRowComponent } from "./components/common/section-instance/attribute-rows/attribute-text-edit-row/attribute-text-edit-row.component";
import { AttributeDateEditRowComponent } from "./components/common/section-instance/attribute-rows/attribute-date-edit-row/attribute-date-edit-row.component";
import { AttributeImageEditRowComponent } from "./components/common/section-instance/attribute-rows/attribute-image-edit-row/attribute-image-edit-row.component";
import { AttributeDropdownEditRowComponent } from "./components/common/section-instance/attribute-rows/attribute-dropdown-edit-row/attribute-dropdown-edit-row.component";
import { StaticTextEditRowComponent } from "./components/common/static-field-rows/static-text-edit-row/static-text-edit-row.component";
import { StaticNumberEditRowComponent } from "./components/common/static-field-rows/static-number-edit-row/static-number-edit-row.component";
import { StaticDateEditRowComponent } from "./components/common/static-field-rows/static-date-edit-row/static-date-edit-row.component";
import { StaticDropdownEditRowComponent } from "./components/common/static-field-rows/static-dropdown-edit-row/static-dropdown-edit-row.component";
import { ImageSectionComponent } from "./components/common/image-section/image-section.component";
import { AssetMapComponent } from "./components/asset-map/asset-map.component";
import { EnumDropdownComponent } from "./components/common/enum-dropdown/enum-dropdown.component";
import { NetworkModelCustomizationComponent } from "./components/network-model-customization/network-model-customization.component";
import { PreviewSchematicDiagramComponent } from "./components/utility-management/preview-schematic-diagram/preview-schematic-diagram.component";
import { CommonEquipmentTemplateComponent } from "./components/network-model-customization/add-equipment-and-connectivity/common-equipment-template/common-equipment-template.component";
import { ObjectDropdownComponent } from "./components/common/object-dropdown/object-dropdown.component";
import { IconColorComponent } from "./components/common/icon-color/icon-color.component";
import { ExpandedSchematicDiagramComponent } from "./components/network-model-customization/add-equipment-and-connectivity/expanded-schematic-diagram/expanded-schematic-diagram.component";
import { PowerTransformerFormComponent } from "./components/network-model-customization/add-equipment-and-connectivity/power-transformer-form/power-transformer-form.component";
import { AddEquipmentAndConnectivityComponent } from "./components/network-model-customization/add-equipment-and-connectivity/add-equipment-and-connectivity.component";
import { NetworkModelNoDataComponent } from "./components/network-model-customization/network-model-no-data/network-model-no-data.component";
import { DataModelCustomizationAttributeComponent } from "./components/data-model-customization/data-model-customization-attribute/data-model-customization-attribute.component";
import { DataModelCustomizationHeaderComponent } from "./components/data-model-customization/data-model-customization-header/data-model-customization-header.component";
import { DataModelCustomizationSectionComponent } from "./components/data-model-customization/data-model-customization-section/data-model-customization-section.component";
import { AddNewSectionComponent } from "./components/data-model-customization/data-model-customization-section/add-new-section/add-new-section.component";
import { DataModelCustomizationSidebarComponent } from "./components/data-model-customization/data-model-customization-sidebar/data-model-customization-sidebar.component";
import { DataModelCustomizationComponent } from "./components/data-model-customization/data-model-customization.component";
import { NetworkStructureComponent } from "./components/data-model-customization/network-structure/network-structure.component";
import { AddNewNetworkDeviceFieldComponent } from "./components/crud/crud-section-definitions/add-new-network-device-field/add-new-network-device-field.component";
import { AddNewSectionDefinitionComponent } from "./components/crud/crud-section-definitions/add-new-section-definition/add-new-section-definition.component";
import { CrudSectionDefinitionsComponent } from "./components/crud/crud-section-definitions/crud-section-definitions.component";
import { ReorderSectionDefinitionComponent } from "./components/crud/crud-section-definitions/reorder-section-definition/reorder-section-definition.component";
import { NetworkDevicesComponent } from "./components/data-model-customization/network-devices/network-devices.component";
import { NetworkLinesComponent } from "./components/data-model-customization/network-lines/network-lines.component";
import { BuildingsCustomersComponent } from "./components/data-model-customization/buildings-customers/buildings-customers.component";
import { MetersComponent } from "./components/data-model-customization/meters/meters.component";
import { ShowMoreComponent } from "./components/common/show-more/show-more.component";
import { PaginationNewComponent } from "./components/pagination-new/pagination-new.component";
import { NecAcLineSegmentComponent } from "./components/network-entity-classes/nec-ac-line-segment/nec-ac-line-segment.component";
import { NecAddEditModalAcLineSegmentComponent } from "./components/network-entity-classes/nec-modals/add-edit-modals/nec-add-edit-modal-ac-line-segment/nec-add-edit-modal-ac-line-segment.component";
import { NecAddEditModalPowerTransformerComponent } from "./components/network-entity-classes/nec-modals/add-edit-modals/nec-add-edit-modal-power-transformer/nec-add-edit-modal-power-transformer.component";
import { NecFilterComponent } from "./components/network-entity-classes/nec-filter/nec-filter.component";
import { PopupMenuFlipDirective } from "./components/network-entity-classes/popup-menu-flip.directive";
import { RegionFilterComponent } from "./components/network-entity-classes/region-filter/region-filter.component";
import { NecBaseVoltageComponent } from "./components/network-entity-classes/nec-base-voltage/nec-base-voltage.component";
import { NecDistrictComponent } from "./components/network-entity-classes/nec-district/nec-district.component";
import { NecPowerTransformerComponent } from "./components/network-entity-classes/nec-power-transformer/nec-power-transformer.component";
import { NecRegionComponent } from "./components/network-entity-classes/nec-region/nec-region.component";
import { NecSubstationComponent } from "./components/network-entity-classes/nec-substation/nec-substation.component";
import { NecSubstationDetailsAcLineComponent } from "./components/network-entity-classes/nec-substation/nec-substation-details/nec-substation-details-ac-line/nec-substation-details-ac-line.component";
import { TimeAgoPipe } from "./pipes/time-ago.pipe";
import { NecSubstationDetailsPowerTransformerComponent } from "./components/network-entity-classes/nec-substation/nec-substation-details/nec-substation-details-power-transformer/nec-substation-details-power-transformer.component";
import { NecSubstationDetailsComponent } from "./components/network-entity-classes/nec-substation/nec-substation-details/nec-substation-details.component";
import { NetworkEntityClassesComponent } from "./components/network-entity-classes/network-entity-classes.component";
import { AnalyticsOverviewComponent } from "./components/dashboard/analytics-overview/analytics-overview.component";
import { MeterValidationCardComponent } from "./components/dashboard/dashboard-meter-validation/meter-validation-card/meter-validation-card.component";
import { DashboardMeterValidationComponent } from "./components/dashboard/dashboard-meter-validation/dashboard-meter-validation.component";
import { OperationsAnalyticsComponent } from "./components/dashboard/operations-analytics/operations-analytics.component";
import { NgChartsModule } from "ng2-charts";
import { ChatIconsModule } from "./components/chat/chat-icons.module";
import { ChatComponent } from "./components/chat/chat.component";
import { ChatMessageComponent } from "./components/chat/chat-message/chat-message.component";
import { ChatResponseMessageComponent } from "./components/chat/chat-response-message/chat-response-message.component";
import { ChatAnswerResponseMessageComponent } from "./components/chat/chat-answer-response-message/chat-answer-response-message.component";
import { ChatErrorResponseMessageComponent } from "./components/chat/chat-error-response-message/chat-error-response-message.component";
import { ChatStatusResponseMessageComponent } from "./components/chat/chat-status-response-message/chat-status-response-message.component";
import { ChatVisualizationResponseMessageComponent } from "./components/chat/chat-visualization-response-message/chat-visualization-response-message.component";
import { TaggedAssetBreakdownComponent } from "./components/dashboard/tagged-asset-breakdown/tagged-asset-breakdown.component";
import { BreakdownDialogComponent } from "./components/dashboard/total-asset-breakdown/breakdown-dialog/breakdown-dialog.component";
import { DonutCardComponent } from "./components/dashboard/total-asset-breakdown/donut-card/donut-card.component";
import { ProgressBarCardComponent } from "./components/dashboard/total-asset-breakdown/progress-bar-card/progress-bar-card.component";
import { TotalAssetBreakdownComponent } from "./components/dashboard/total-asset-breakdown/total-asset-breakdown.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { LoginComponent } from "./components/login/login.component";
import { RouterModule } from "@angular/router";
import { ForgotPasswordComponent } from "./components/login/forgot-password/forgot-password.component";
import { HelpComponent } from "./components/login/help/help.component";
import { NecConnectorSwitchComponent } from "./components/network-entity-classes/nec-connector-switch/nec-connector-switch/nec-connector-switch.component";
import { NecConnectorSwitchContainerComponent } from "./components/network-entity-classes/nec-connector-switch/nec-connector-switch-container/nec-connector-switch-container.component";
import { NecAddEditModalConnectorSwitchComponent } from "./components/network-entity-classes/nec-modals/add-edit-modals/nec-add-edit-modal-connector-switch/nec-add-edit-modal-connector-switch.component";
import { NecAddEditModalSubstationComponent } from "./components/network-entity-classes/nec-modals/add-edit-modals/nec-add-edit-modal-substation/nec-add-edit-modal-substation.component";
import { NecAddNewInstanceEquipmentComponent } from "./components/network-entity-classes/nec-modals/nec-add-new-instance-equipment/nec-add-new-instance-equipment.component";
import { NecSubstationDetailsEquipmentComponent } from "./components/network-entity-classes/nec-substation/nec-substation-details/nec-substation-details-equipment/nec-substation-details-equipment.component";
import { SubstationTemplatesComponent } from "./components/data-model-customization/substation-templates/substation-templates.component";
import { NecAddIncommingLineToSsModalComponent } from "./components/network-entity-classes/nec-modals/add-edit-modals/nec-add-incomming-line-to-ss-modal/nec-add-incomming-line-to-ss-modal.component";
import { CimSubstationEquipmentSchematicComponent } from './components/advanced-map/cim-substation-equipment-schematic/cim-substation-equipment-schematic.component';
import { EquipmentSectionComponent } from './components/common/equipment-section/equipment-section.component';
import { CustomerApplicationComponent } from "./components/data-model-customization/customer-application/customer-application.component";
import { DedicatedSupplyRequestsComponent } from "./components/data-model-customization/dedicated-supply-requests/dedicated-supply-requests.component";
import { ServiceExtensionComponent } from "./components/data-model-customization/service-extension/service-extension.component";
import { DisconnectionRequestsComponent } from "./components/data-model-customization/disconnection-requests/disconnection-requests.component";
import { CimSubstationListComponent } from "./components/cim-substations/cim-substation-list/cim-substation-list.component";
import { EditCimSubstationComponent } from "./components/cim-substations/edit-cim-substation/edit-cim-substation.component";
import { CimEquipmentListComponent } from "./components/cim-equipment/cim-equipment-list/cim-equipment-list.component";
import { DataQualityComponent } from "./components/common/data-quality/data-quality.component";
import { MultiSelectDropdownComponent } from "./components/common/multi-select-dropdown/multi-select-dropdown.component";
import { AdvMapSchematicTabsComponent } from './components/advanced-map/adv-map-schematic-tabs/adv-map-schematic-tabs.component';
import { NecUploadModalPowerTransformerComponent } from "./components/network-entity-classes/nec-modals/upload-modals/nec-upload-modal-power-transformer/nec-upload-modal-power-transformer.component";
import { EditCimEquipmentComponent } from './components/cim-equipment/edit-cim-equipment/edit-cim-equipment.component';
import { AcLineSchematicComponent } from './components/advanced-map/ac-line-schematic/ac-line-schematic.component';
import { NecSubstationDetailsSchematicComponent } from './components/network-entity-classes/nec-substation/nec-substation-details/nec-substation-details-schematic/nec-substation-details-schematic.component';
import { NecTransformerRatingComponent } from './components/network-entity-classes/nec-transformer-rating/nec-transformer-rating.component';
import { NecStatsByTemplateComponent } from "./components/network-entity-classes/nec-stats-by-template/nec-stats-by-template.component";
import { CimSubstationMapFullDetailsComponent } from './components/advanced-map/advanced-map-full-details/cim-substation-map-full-details/cim-substation-map-full-details.component';
import { NecAcLineSchematicComponent } from './components/network-entity-classes/nec-ac-line-segment/nec-ac-line-schematic/nec-ac-line-schematic.component';
import { AdvMapSchematicFilterComponent } from './components/advanced-map/adv-map-schematic-filter/adv-map-schematic-filter.component';
import { SchematicLegendComponent } from './components/schematic/schematic-legend/schematic-legend.component';
import { OtpVerificationComponent } from "./components/login/otp-verification/otp-verification.component";
import { ReviewComponent } from "./components/review/review.component";
import { GojsSchematicComponent } from "./components/gojs-schematic/gojs-schematic.component";

@NgModule({
  declarations: [
    TestComponent,
    AssetListPaginationComponent,
    HasValuePipe,
    CrudTsComponent,
    AiOverviewComponent,
    OverviewCardComponent,
    AiSegmentationListComponent,
    CardComponent,
    GeneratedObjectRepresentationComponent,
    BatchImageImportComponent,
    AiJobMonitoringComponent,
    DynamicSubstationListComponent,
    DynamicCardsComponent,
    AssetListHeaderComponent,
    EmcSearchComponentComponent,
    FilterChecklistComponent,
    DynamicFilterWindowComponent,
    FilterDynamicComponent,
    EditInjectionSubstationComponent,
    AssignTaskModalComponent,
    AuditReviewComponent,
    SectionInstanceColumnComponent,
    SectionInstanceCardComponent,
    AttributeSelectedOptionsRowComponent,
    AttributeFileRowComponent,
    AttributeLocationRowComponent,
    AttributeValueRowComponent,
    AttributeImageRowComponent,
    AttributeNumberEditRowComponent,
    AttributeTextEditRowComponent,
    AttributeDateEditRowComponent,
    AttributeImageEditRowComponent,
    AttributeDropdownEditRowComponent,
    StaticTextEditRowComponent,
    StaticNumberEditRowComponent,
    StaticDateEditRowComponent,
    StaticDropdownEditRowComponent,
    ImageSectionComponent,
    AssetMapComponent,
    EnumDropdownComponent,
    NetworkModelCustomizationComponent,
    PreviewSchematicDiagramComponent,
    CommonEquipmentTemplateComponent,
    ObjectDropdownComponent,
    IconColorComponent,
    ExpandedSchematicDiagramComponent,
    PowerTransformerFormComponent,
    AddEquipmentAndConnectivityComponent,
    NetworkModelNoDataComponent,
    DataModelCustomizationAttributeComponent,
    DataModelCustomizationHeaderComponent,
    DataModelCustomizationSectionComponent,
    AddNewSectionComponent,
    DataModelCustomizationSidebarComponent,
    DataModelCustomizationComponent,
    NetworkStructureComponent,
    AddNewNetworkDeviceFieldComponent,
    AddNewSectionDefinitionComponent,
    CrudSectionDefinitionsComponent,
    ReorderSectionDefinitionComponent,
    NetworkDevicesComponent,
    NetworkLinesComponent,
    BuildingsCustomersComponent,
    MetersComponent,
    ShowMoreComponent,
    PaginationNewComponent,
    NecAcLineSegmentComponent,
    NecAddEditModalAcLineSegmentComponent,
    NecAddEditModalPowerTransformerComponent,
    NecAddEditModalConnectorSwitchComponent,
    NecAddEditModalSubstationComponent,
    NecAddNewInstanceEquipmentComponent,
    NecFilterComponent,
    RegionFilterComponent,
    NecBaseVoltageComponent,
    NecDistrictComponent,
    NecPowerTransformerComponent,
    NecRegionComponent,
    NecSubstationComponent,
    NecSubstationDetailsAcLineComponent,
    NecSubstationDetailsPowerTransformerComponent,
    NecSubstationDetailsEquipmentComponent,
    NecSubstationDetailsComponent,
    NecConnectorSwitchComponent,
    NecConnectorSwitchContainerComponent,
    NetworkEntityClassesComponent,
    PopupMenuFlipDirective,
    OverviewDetailCardComponent,
    AnalyticsOverviewComponent,
    MeterValidationCardComponent,
    DashboardMeterValidationComponent,
    OperationsAnalyticsComponent,
    TaggedAssetBreakdownComponent,
    BreakdownDialogComponent,
    DonutCardComponent,
    ProgressBarCardComponent,
    TotalAssetBreakdownComponent,
    DashboardComponent,
    LoginComponent,
    ForgotPasswordComponent,
    HelpComponent,
    CimSubstationEquipmentSchematicComponent,
    EquipmentSectionComponent,
    SubstationTemplatesComponent,
    NecAddIncommingLineToSsModalComponent,
    CustomerApplicationComponent,
    DedicatedSupplyRequestsComponent,
    ServiceExtensionComponent,
    DisconnectionRequestsComponent,
    CimSubstationListComponent,
    EditCimSubstationComponent,
    CimEquipmentListComponent,
    DataQualityComponent,
    MultiSelectDropdownComponent,
    AdvMapSchematicTabsComponent,
    NecUploadModalPowerTransformerComponent,
    EditCimEquipmentComponent,
    AcLineSchematicComponent,
    NecSubstationDetailsSchematicComponent,
    NecTransformerRatingComponent,
    NecStatsByTemplateComponent,
    CimSubstationMapFullDetailsComponent,
    NecAcLineSchematicComponent,
    AdvMapSchematicFilterComponent,
    SchematicLegendComponent,
    OtpVerificationComponent,
    ReviewComponent,
    GojsSchematicComponent,
    ChatComponent,
    ChatMessageComponent,
    ChatResponseMessageComponent,
    ChatAnswerResponseMessageComponent,
    ChatErrorResponseMessageComponent,
    ChatStatusResponseMessageComponent,
    ChatVisualizationResponseMessageComponent
  ],
  imports: [
    TimeAgoPipe,
    CommonModule,
    FormsModule,
    NgxImageZoomModule,
    GoogleMapsModule,
    ColorSketchModule,
    TranslateModule.forChild(),
    DragDropModule,
    NgChartsModule,
    RouterModule,
    ChatIconsModule
  ],
  exports: [
    TestComponent,
    CrudTsComponent,
    AssetListPaginationComponent,
    TranslateModule,
    HasValuePipe,
    TimeAgoPipe,
    AiOverviewComponent,
    OverviewCardComponent,
    OverviewDetailCardComponent,
    AiSegmentationListComponent,
    CardComponent,
    GeneratedObjectRepresentationComponent,
    BatchImageImportComponent,
    AiJobMonitoringComponent,
    DynamicSubstationListComponent,
    DynamicCardsComponent,
    AssetListHeaderComponent,
    EmcSearchComponentComponent,
    FilterChecklistComponent,
    DynamicFilterWindowComponent,
    FilterDynamicComponent,
    EditInjectionSubstationComponent,
    AssignTaskModalComponent,
    AuditReviewComponent,
    SectionInstanceColumnComponent,
    SectionInstanceCardComponent,
    AttributeSelectedOptionsRowComponent,
    AttributeFileRowComponent,
    AttributeLocationRowComponent,
    AttributeValueRowComponent,
    AttributeImageRowComponent,
    AttributeNumberEditRowComponent,
    AttributeTextEditRowComponent,
    AttributeDateEditRowComponent,
    AttributeImageEditRowComponent,
    AttributeDropdownEditRowComponent,
    StaticTextEditRowComponent,
    StaticNumberEditRowComponent,
    StaticDateEditRowComponent,
    StaticDropdownEditRowComponent,
    ImageSectionComponent,
    AssetMapComponent,
    EnumDropdownComponent,
    NetworkModelCustomizationComponent,
    PreviewSchematicDiagramComponent,
    CommonEquipmentTemplateComponent,
    ObjectDropdownComponent,
    IconColorComponent,
    ExpandedSchematicDiagramComponent,
    PowerTransformerFormComponent,
    AddEquipmentAndConnectivityComponent,
    NetworkModelNoDataComponent,
    DataModelCustomizationAttributeComponent,
    DataModelCustomizationHeaderComponent,
    DataModelCustomizationSectionComponent,
    AddNewSectionComponent,
    DataModelCustomizationSidebarComponent,
    DataModelCustomizationComponent,
    NetworkStructureComponent,
    AddNewNetworkDeviceFieldComponent,
    AddNewSectionDefinitionComponent,
    CrudSectionDefinitionsComponent,
    ReorderSectionDefinitionComponent,
    NetworkDevicesComponent,
    NetworkLinesComponent,
    BuildingsCustomersComponent,
    MetersComponent,
    ShowMoreComponent,
    PaginationNewComponent,
    NecAcLineSegmentComponent,
    NecAddEditModalAcLineSegmentComponent,
    NecAddEditModalPowerTransformerComponent,
    NecAddEditModalConnectorSwitchComponent,
    NecAddEditModalSubstationComponent,
    NecAddNewInstanceEquipmentComponent,
    NecFilterComponent,
    RegionFilterComponent,
    NecBaseVoltageComponent,
    NecDistrictComponent,
    NecPowerTransformerComponent,
    NecRegionComponent,
    NecSubstationComponent,
    NecSubstationDetailsAcLineComponent,
    NecSubstationDetailsPowerTransformerComponent,
    NecSubstationDetailsEquipmentComponent,
    NecSubstationDetailsComponent,
    NecConnectorSwitchComponent,
    NecConnectorSwitchContainerComponent,
    NetworkEntityClassesComponent,
    AnalyticsOverviewComponent,
    MeterValidationCardComponent,
    DashboardMeterValidationComponent,
    OperationsAnalyticsComponent,
    TaggedAssetBreakdownComponent,
    BreakdownDialogComponent,
    DonutCardComponent,
    ProgressBarCardComponent,
    TotalAssetBreakdownComponent,
    DashboardComponent,
    LoginComponent,
    ForgotPasswordComponent,
    HelpComponent,
    SubstationTemplatesComponent,
    NecAddIncommingLineToSsModalComponent,
    CimSubstationEquipmentSchematicComponent,
    CustomerApplicationComponent,
    DedicatedSupplyRequestsComponent,
    ServiceExtensionComponent,
    DisconnectionRequestsComponent,
    CimSubstationListComponent,
    EditCimSubstationComponent,
    CimEquipmentListComponent,
    AdvMapSchematicTabsComponent,
    NecUploadModalPowerTransformerComponent,
    DataQualityComponent,
    EditCimEquipmentComponent,
    AcLineSchematicComponent,
    NecTransformerRatingComponent,
    NecStatsByTemplateComponent,
    CimSubstationMapFullDetailsComponent,
    NecAcLineSchematicComponent,
    AdvMapSchematicFilterComponent,
    SchematicLegendComponent,
    OtpVerificationComponent,
    ReviewComponent,
    GojsSchematicComponent,
    ChatComponent
  ]
})
export class SharedLibModule { }